<template>
  <v-container fluid class="help">
    <v-row>
      <v-col class="text-center">
        <h1>Forms</h1>
        <br><br>      
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-col
        v-for="card in cards"
        :key="card.id"
        class="d-flex child-flex"
        cols="12"
        sm="3"
      >
        <v-card>
          <!--
          <v-img
          :src="card.src"
          :lazy-src="card.src"
          aspect-ratio="1"
          class="grey lighten-2"
          height="150px"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          -->
          <v-card-title>{{card.title}}</v-card-title>
          <v-card-actions>
            <v-btn
              color="orange"
              text
              :href="card.link"
              target="_blank"
            >
              View
            </v-btn>
            </v-card-actions>
        </v-card>
        <br>
      </v-col>
    </v-row>
    <br><br>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    cards: [
      { 
        id: '0', 
        title: 'Promotion Request', 
        //src: require('@/assets/img_sales_tool/survey-form-review-policy-campaign.png'),
        link: 'https://teraslegacy.com/wp-content/uploads/2022/02/Promotion-Request-14092021-V2.pdf', 
      },
      { 
        id: '1', 
        title: 'Auto Credit Form', 
        //src: require('@/assets/img_sales_tool/survey-form.png'),
        link: 'https://teraslegacy.com/wp-content/uploads/2022/02/AUTO-CREDIT-FORMS.pdf', 
      },
      { 
        id: '2', 
        title: 'Volunteer Reposition Request', 
        //src: require('@/assets/img_sales_tool/Survey-Form_Freedom-concept-2021.png'),
        link: 'https://teraslegacy.com/wp-content/uploads/2022/02/Volunteer-Reposition-Request.pdf',  
      },
    ],
  }),
}
</script>
